<!--contents-->
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <div class="column" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
    <ng-container *ngIf="isOnPremiseMode; then standaloneLicenseTexts else licenseTexts"></ng-container>
    <div class="button-div" fxLayout="row" fxLayoutAlign="center" *ngIf="isFirst">
      <mat-dialog-actions>
        <button class="disagree-button" mat-button color="primary" (click)="cancel()">{{'licenseagreement.iDisagree' | translate}}</button>
        <button  mat-raised-button color="primary" (click)="agree()">{{'licenseagreement.iAgree' | translate}}</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>

<ng-template #standaloneLicenseTexts>
  <!-- For IPLEX Mode license text. -->
  <app-standalone-license-texts class="eula"></app-standalone-license-texts>
</ng-template>
<ng-template #licenseTexts>
  <!-- For other license text. -->
  <app-license-texts id="eula"
                     class="eula"></app-license-texts>
</ng-template>
